// extracted by mini-css-extract-plugin
export default {"benefits":"styles_benefits__ZZ2NP","title":"styles_title__84gjQ","list":"styles_list__8qbyS","listItem":"styles_listItem__qF8QP","icon":"styles_icon__Z1FBR"};